// extracted by mini-css-extract-plugin
export default {"container":"sP-z","darkBackground":"tP-z","whiteBackground":"uP-z","headerButton":"vP-z","calloutHeading":"wP-z","calloutSubHeading":"xP-z"};